<div
    *ngIf="jswAuthFailed$ | async"
    class="alert alert-warning jsw-auth-banner d-flex justify-content-between align-items-center mb-3"
    role="alert"
>
    <span class="jsw-auth-banner__message">
        <i class="ri-error-warning-line me-2"></i>
        JSW authentication failed, click here to re-authenticate.
    </span>
    <button
        type="button"
        class="btn btn-sm btn-warning"
        [disabled]="busy"
        (click)="onReauthenticate()"
    >
        <ng-container *ngIf="!busy">Re-authenticate</ng-container>
        <ng-container *ngIf="busy">Re-authenticating...</ng-container>
    </button>
</div>
